type Path<T> = {
  (params?: Record<string, string | number | boolean>): string
  path: T
  element: React.ReactNode | null
}

export function createPath<T extends string>(path: T, element: React.ReactNode | null): Path<T> {
  const pathPlaceholders = path.match(/:\w+\??/g)
  if (pathPlaceholders) {
    const unique = new Set(pathPlaceholders)
    if (unique.size !== pathPlaceholders.length)
      throw new Error(`Placeholder :${pathPlaceholders[0].slice(1)} is used multiple times in path ${path}`)
  }

  const f = (params: Record<string, string | number | boolean> = {}): string => {
    if (path.includes(':') && !params) throw new Error('Params are required')

    // find all params in path by :\w+ and check that they are all in params
    const pathPlaceholders = path.match(/:\w+\??/g)?.map((key) => key.slice(1)) || []

    let realPath = path as string
    for (const key of pathPlaceholders) {
      const optionalSegment: boolean = key.endsWith('?')

      const paramsKey = key.replace('?', '')
      const paramValue = params[paramsKey] as string

      // optional segments could be undefined, we just remove them from path
      if (paramValue === undefined) {
        if (!optionalSegment) {
          throw new Error(`Value for placeholder :${key} is not provided for path ${path}`)
        }
        realPath = realPath.replace(`:${key}/`, '')
      } else {
        realPath = realPath.replaceAll(`:${key}`, paramValue)
      }
    }
    return realPath
  }

  return Object.assign(f, { path, element })
}
